<template lang="pug">
.ledger-accounts
  h2.mb-S Ledger accounts
  BriqInput(label="PLU" name="PluNumber" placeholder="PLU" v-model="product.PluNumber" :disabled="disabled" )
  BriqMultiselect(
    label="Ledger account"
    placeholder="Select ledger account"
    :options="ledgerAccountOptions"
    :valueSetter="o => o.Key"
    track-by="Key"
    display="Name"
    v-model="product.LedgerAccountKey"
    :disabled="disabled"
    )
  BriqMultiselect(
    label="Cost center"
    :placeholder="costCenterOptions.length === 0 ? '' : 'Select cost center'"
    :options="costCenterOptions"
    :valueSetter="o => o.Key"
    track-by="Key"
    display="Name"
    v-model="product.CostCenterKey"
    :disabled="disabled || costCenterOptions.length === 0"
    )
  BriqMultiselect(
    label="Discount ledger account"
    :placeholder="discountLedgerAccountOptions.length === 0 ? '' : 'Select discount ledger account'"
    :options="discountLedgerAccountOptions"
    :valueSetter="o => o.Key"
    track-by="Key"
    display="Name"
    v-model="product.DiscountLedgerAccountKey"
    :disabled="disabled || discountLedgerAccountOptions.length === 0"
    )
  BriqMultiselect(
    label="Discount cost center"
    :placeholder="costCenterOptions.length === 0 ? '' : 'Select discount cost center'"
    :options="costCenterOptions"
    :valueSetter="o => o.Key"
    track-by="Key"
    display="Name"
    v-model="product.DiscountCostCenterKey"
    :disabled="disabled || costCenterOptions.length === 0"
    )
</template>

<script>
import { filter, prop, assoc } from 'ramda'

export default {
  name: 'LedgerAccounts',
  components: {},
  props: {
    product: { type: Object, required: true },
    disabled: Boolean,
  },
  data() {
    return {}
  },
  computed: {
    activeLedgerAccounts() {
      const filterActive = filter(prop('Active'))
      return filterActive(this.ledgerAccounts)
    },
    discountLedgerAccounts() {
      return this.activeLedgerAccounts.reduce(
        (a, n) => assoc(n.Key, n.DiscountLedgerAccounts.filter(prop('Active')), a),
        {},
      )
    },
    costCenters() {
      return this.activeLedgerAccounts.reduce(
        (a, n) => assoc(n.Key, n.CostCenters.filter(prop('Active')), a),
        {},
      )
    },
    ledgerAccountOptions() {
      return this.activeLedgerAccounts || []
    },
    costCenterOptions() {
      return this.costCenters &&
        this.product.LedgerAccountKey &&
        this.costCenters[this.product.LedgerAccountKey]
        ? this.costCenters[this.product.LedgerAccountKey]
        : []
    },
    discountLedgerAccountOptions() {
      return this.discountLedgerAccounts &&
        this.product.LedgerAccountKey &&
        this.discountLedgerAccounts[this.product.LedgerAccountKey]
        ? this.discountLedgerAccounts[this.product.LedgerAccountKey]
        : []
    },
  },
}
</script>

<style scoped lang="stylus"></style>
